import React, { useState } from 'react'
import { useMutation } from '@apollo/client'
import classNames from 'classnames'
import { Button } from '@winnin/winnin_ui.components.button'
import { Icon } from '@winnin/winnin_ui.components.icon'
import { Loading } from '@winnin/winnin_ui.components.loading'

import { filterOptions } from 'consts'
import { T } from 'lib/tolgee'
import TOLGEE_GLOBALS from 'utils/tolgeeGlobals'

import { REMOVE_FILTER } from '../query'

export default function SavedAudiences({ onTrack, changeAudienceFilter, onApply, onCancel, data, loading }) {
  const [removeFilter, { loading: loadingFilter }] = useMutation(REMOVE_FILTER, {
    onError(error) {
      console.error('Remove Filter @ REMOVE_FILTER', error)
    },
    refetchQueries: ['getWorkspaceSavedFilters'],
  })

  const { ages, genders, audienceCountries } = filterOptions
  const [activeItem, setActiveItem] = useState()

  const formatBackendFilters = () => {
    if (!data) return []
    return data?.getWorkspaceSavedFilters?.map(item => {
      const formattedGender =
        genders?.find(gender => gender.value === item.filter.gender) ||
        genders?.find(gender => gender.key === item.filter.gender)
      const formattedAge =
        item.filter.age.length === 0
          ? ages?.filter(e => e.key === 'all')
          : ages?.filter(e => item.filter.age?.indexOf(e.value) !== -1)
      const formattedCountry =
        audienceCountries?.find(country => country.value === item.filter.country) ||
        audienceCountries?.find(country => country.key === item.filter.country)
      const allAgesLabel =
        formattedAge?.length > 1 ? formattedAge?.map(age => age?.label).join(', ') : formattedAge[0]?.label
      const allGendersLabel = formattedGender?.label === 'All' ? 'All Genders' : formattedGender?.label
      const formattedGendersAgesCountryLabel = allGendersLabel?.concat(
        ', ',
        allAgesLabel,
        ', ',
        formattedCountry?.label
      )

      return {
        id: item.id,
        label: formattedGendersAgesCountryLabel,
        value: {
          audienceAges: formattedAge,
          audienceGenders: formattedGender,
          audienceCountries: formattedCountry,
        },
      }
    })
  }

  const handleOnApply = () => {
    changeAudienceFilter?.('audienceAges', activeItem.audienceAges)
    changeAudienceFilter?.('audienceGenders', activeItem.audienceGenders)
    changeAudienceFilter?.('audienceCountries', activeItem.audienceCountries)

    onApply?.(activeItem)
    onTrack?.(activeItem)
  }

  const handleOnClick = value => {
    setActiveItem(value)
  }

  const handleDelete = value => {
    removeFilter({
      variables: {
        id: value,
      },
    })
  }

  if (loading || loadingFilter) return <Loading topMargin showMessage />

  return (
    <>
      <div className="stored-audience-list">
        {formatBackendFilters().length > 0 ? (
          formatBackendFilters().map(item => {
            const isActive = JSON.stringify(activeItem) === JSON.stringify(item.value)
            return (
              <div className={classNames('item', { active: isActive })} key={item.id} title={item.label}>
                <button
                  className="content"
                  type="button"
                  onClick={() => {
                    handleOnClick(item.value)
                  }}
                >
                  {item.label}
                </button>
                <button
                  className="delete"
                  type="button"
                  onClick={() => {
                    handleDelete(item.id)
                  }}
                >
                  <Icon
                    width={10}
                    height={10}
                    className={classNames('icon', { active: isActive })}
                    icon="smallClose"
                    fill="var(--gray_dark2)"
                  />
                </button>
              </div>
            )
          })
        ) : (
          <div>
            <T keyName="SavedAudiences-noAudienceText">No audiences currently stored</T>
          </div>
        )}
      </div>
      <div className="audience-actions">
        <div className="buttonWrapper">
          <Button onClick={onCancel} appearance="link">
            <T keyName={TOLGEE_GLOBALS.cancel.key}>{TOLGEE_GLOBALS.cancel.defaultValue}</T>
          </Button>
          <Button onClick={handleOnApply} disabled={!activeItem}>
            <T keyName={TOLGEE_GLOBALS.apply.key}>{TOLGEE_GLOBALS.apply.defaultValue}</T>
          </Button>
        </div>
      </div>
    </>
  )
}
